import React, { useState, useEffect } from "react";
import { loadStripe } from "@juspay-tech/orca-js";
import { Elements, PaymentElement } from "@juspay-tech/react-orca-js";
import { Button, SHAPE } from "baseui/button";
import { Card } from "baseui/card";
import HeadingSection from "../components/Heading";
import { Spinner } from "baseui/spinner";
import { UserContext } from '../App';
import hintIcon from '../assets/hintIcon.png';
import { paymentData } from "../utils/data";
import { Notification, KIND as NKIND } from "baseui/notification";
import { useSnackbar } from 'baseui/snackbar';
import { baseUrl, getHeader, pkKey } from "../utils/consts";
import { Drawer } from "baseui/drawer";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(pkKey);

const appearance = {
    theme: 'default',
};

const PaymentPage = () => {
    const { enqueue } = useSnackbar();
    let navigate = useNavigate();
    let { orcaAPIKey, selectedPg } = React.useContext(UserContext);
    const [response, setResponse] = useState("");
    const [elementLoaded, setElementLoaded] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isOpen, setIsOpen] = useState(true);

    const setMessage = (message, bgColor) => {
        enqueue({
            message: message,
            overrides: {
                Root: { style: { width: 'auto', backgroundColor: bgColor } },
            }
        })
    }

    let makePaymant = () => {
        setResponse("")
        setIsLoading(true)
        fetch(`${baseUrl}/payments`, {
            method: 'POST',
            headers: getHeader(orcaAPIKey),
            body: paymentData
        }).then((res) => {
            if (res.status === 200) {
                res.json().then(val => {
                    let { status } = val
                    if (status === "succeeded") {
                        setResponse(selectedPg)
                        navigate("/payment-success")
                    } else {
                        setResponse("")
                        setMessage("Payment Failed", "red")
                    }
                })
            } else {
                res.text().then(val =>
                    console.log("Network Error:-", JSON.parse(val).error.message)
                )
                setResponse("")
                setMessage("Payment Failed", "red")
                navigate("/payment-success")
            }
            setIsLoading(false)
        }).catch(err => {
            console.log("ERROR:- ", err.message)
            setMessage("There was an error!", "red")
            setIsLoading(false)
        }
        );
    }


    useEffect(() => {
        fetch("/create-payment-intent", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
        })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret))
            .catch(err => {
                console.log("ERROR:- ", err.message)
            });
    }, []);

    const options = {
        clientSecret,
        appearance,
    };

    let onReady = () => {
        setElementLoaded(true)
    }

    let onChange = (data) => {
        let { empty } = data
        if (empty) setIsDisabled(true)
        else setIsDisabled(false)
    }

    return (
        <Elements options={options} stripe={stripePromise}>
            <div className="w-full" ><div className="max-w-2xl mx-auto">
                <Card>
                    <div className="p-5" >
                        <HeadingSection iconEnabled={true} headerWrapperClass={'mt-1 pl-32 mb-8'} title={"Make a Payment"} backUrl={"/payment-gateways"} />
                        <div className="w-full flex justify-center" >
                    <div className="mt-6 mb-5 font-bold text-gray-600" ><div className="text-4xl mt-1 text-black" > $500.0</div>Payment amount:</div>
                    </div>
                        {
                            !elementLoaded ? <div className="flex flex-col justify-center h-52" ><div className="mx-auto" ><Spinner /></div></div> : <div />
                        }
                        <div className={`${elementLoaded ? "" : "hidden"}`} >
                            <PaymentElement onChange={onChange} onReady={onReady} id="payment-element" /
                            ></div>

                        <div className='mt-5' >
                            <Button style={{ width: "100%" }} onClick={makePaymant} disabled={isDisabled} isLoading={isLoading} >Pay Now</Button>
                        </div>
                    </div>
                </Card>
                {
                    response !== "" && (<div className="w-fit max-w-2xl mx-auto mt-20" >
                        <Notification kind={NKIND.positive} overrides={{
                            Body: { style: { width: 'auto' } },
                        }}>
                            {() => <div>This Payment is made through <b>{response}</b> Payment Gateway</div>}
                        </Notification>
                    </div>)
                }
            </div>
                <div className="absolute bottom-10 right-10" >

                    <Button shape={SHAPE.circle} onClick={() => setIsOpen(isOpen => !isOpen)} >
                        <div className="w-4 h-4" >
                            <img src={hintIcon} style={{ scale: "3" }} alt="" />
                        </div></Button>

                    <Drawer
                        isOpen={isOpen}
                        autoFocus
                        onClose={() => setIsOpen(false)}
                    >
                        <Card>
                            <div className="text-lg font-semibold" >Demo in test mode</div>
                            <div className="opacity-70 pb-3" >You can copy and paste the following test card details to test a payment</div>
                            <div className="">
                                <div className="font-medium" >Card Number&nbsp;:<span className="ml-5 mb-2 font-normal" >4242 4242 4242 4242</span></div>
                                <div className="font-medium" >Card Expiry&nbsp;&nbsp;&nbsp;&nbsp;:<span className="ml-5 mb-2 font-normal" >04/24</span></div>
                                <div className="font-medium" >Card CVC&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:<span className="ml-5 mb-2 font-normal" >242</span></div>
                            </div>
                        </Card>
                    </Drawer>
                </div>
            </div>
        </Elements>)
}

export default PaymentPage